import Tick from './Tick';

export default Tick;
